import { Button } from '@jfs/ui-new'
import { ActionType } from './types'

const getDeleteView = (entry: any, executeAction: (actionType: ActionType) => void) => {
  const processRefund = () => {
    executeAction(ActionType.DeleteBulkRefund)
  }
  return (
    <Button onPress={processRefund} testID="btn-DeleteBulkRefund" color={'ERROR'} type={'IconLH'}>
      {entry.value}
    </Button>
  )
}

export { getDeleteView }
